/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Dobre_NemovitostiInputs */

const cs_enum_dobre_nemovitosti = /** @type {(inputs: Enum_Dobre_NemovitostiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobré nemovitosti`)
};

const en_enum_dobre_nemovitosti = /** @type {(inputs: Enum_Dobre_NemovitostiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobré nemovitosti`)
};

/**
* | output |
* | --- |
* | "Dobré nemovitosti" |
*
* @param {Enum_Dobre_NemovitostiInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_dobre_nemovitosti = /** @type {((inputs?: Enum_Dobre_NemovitostiInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Dobre_NemovitostiInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_dobre_nemovitosti(inputs)
	return cs_enum_dobre_nemovitosti(inputs)
});